import { enumBranchStyle } from "../constants";

export function IsMultiColumnStyle(branchStyle) {
  var multiColumn = false;
  switch (branchStyle) {
    case enumBranchStyle.twocolumn:
    case enumBranchStyle.fourcolumn:
    case enumBranchStyle.sixcolumn:
    case enumBranchStyle.eightcolumn:
    case enumBranchStyle.twelvecolumn:
    case enumBranchStyle.sixteencolumn:
    case enumBranchStyle.twentycolumn:
      multiColumn = true;
      break;
  }

  return multiColumn;
}
